<template>
  <div class="wrapper">
    <!-- loading -->
    <Loading v-if="loading" @loaded="loaded" />

    <!-- 页面组件 -->
    <component :is="currentPageComponent" v-if="!loading" />

    <!-- 弹出框 -->
    <Pop></Pop>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapState, mapActions } from 'vuex';
import { showPage } from '@/utils/common.js';
import Loading from '@/views/Loading.vue'; // 导入 Loading 组件
import Pop from '@/components/pop/Pop.vue'

export default {
  data() {
    return {
      loading: true, // 是否在加载中
    };
  },
  components: {
    Loading,
    Pop
  },
  computed: {
    ...mapState(['currentPage', 'shareURL']),
    currentPageComponent() {
      switch (this.currentPage) {
        case 'Loading':
          return Loading; // 使用已导入的 Loading 组件
        case 'Guide':
          return defineAsyncComponent(() => import('@/views/Guide.vue'));
        case 'Home':
          return defineAsyncComponent(() => import('@/views/Home.vue'));
        case 'GetHead':
          return defineAsyncComponent(() => import('@/views/GetHead.vue'));
        case 'HeadList':
          return defineAsyncComponent(() => import('@/views/HeadList.vue'));
        default:
          return null;
      }
    }
  },
  created() {
		this.share();
	},
  mounted() {
    this.updateInitUser();
  },
  methods: {
    ...mapActions(['updateInitUser']),
    showPage,
    loaded(){
      this.loading = false;
    },
    share(){
			shareWeixinFun({
				title: "幻塔真的有毒！",
				desc: "三周年毒性头像大派发，快来收集领赤核~",
				link: this.shareURL,
				imgUrl: require('@images/share.jpeg')
			});
		}
  },
};
</script>

<style scoped>
@import url(@style/base.css);

.wrapper { height: 100%; background: #EEE url(@images/wrapper.jpg) no-repeat center top;}
</style>
